import { settingsReducer } from './settings.reducer';

export {
  settingsReducer
}



// WEBPACK FOOTER //
// src/common/settings/index.js